<!-- Add/Edit Article Modal -->
<div class="modal-header">
    <h5 class="modal-title" id="editAdTitle">Edit Ad</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <!-- <div class="row">
        <div class="col-12 mb-3">
            <label for="articleTitle" class="form-label">Article Title</label>
            <input type="text" class="form-control" id="articleTitle" placeholder="Article Title">
        </div>
    </div> -->
    <div class="row">
        <div class="col-12 mb-3">
            <label for="adImg" class="form-label">Upload New Advertisement</label>
            <input (change)="updateAdImageFile($event.target.files)" class="form-control" type="file" id="adImg">
        </div>
    </div>
    <div class="row">
        <div class="mb-4">
            <label for="runDate" class="form-label">Date To Run</label>
            <input [(ngModel)]="runDate" type="text" class="form-control"
                    id="runDate" placeholder="mm/dd/yyyy" (change)="runDateChange()">
            <div *ngIf="invalidRunDate">
                <i class="fas fa-exclamation-circle"></i> Date is invalid.
            </div>
        </div>
    </div>
    <div class="row">
        <div class="mb-4">
            <label for="endDate" class="form-label">End Date</label>
            <input [(ngModel)]="endDate" type="text" class="form-control"
                    id="endDate" placeholder="mm/dd/yyyy">
            <div *ngIf="invalidEndDate">
                <i class="fas fa-exclamation-circle"></i> Date is invalid.
            </div>
        </div>
    </div>
    <!--<div class="row">
        <div class="col-12 mb-3">
            <label for="articleContent" class="form-label">Article Content</label>
            <textarea class="form-control" id="articleContent" rows="10"></textarea>
        </div>
    </div>-->
</div>
<div class="modal-footer">
    <button type="button" (click)="submitUpdatedAd()" class="btn btn-sb border-lb text-strong text-uppercase m-100" data-bs-dismiss="modal">Save</button>
    <button type="button" class="btn btn-cancel text-strong text-uppercase m-100" (click)="dismiss()">Cancel</button>
</div>